export type LogSource = 'Tour' | 'Kafka' | 'Driver app' | 'Notification';

export const LOG_SOURCES: LogSource[] = ['Tour', 'Driver app', 'Notification', 'Kafka'];

export interface LogEntry {
  id: string;
  timestamp: string;
  source: LogSource;
  name: string;
  details: string;
  significant: boolean;
  severity: 'info' | 'success' | 'warning' | 'danger';
}

export interface Breakdown {
  id?: string;
  label: string;
  value: number;
}

export interface SeriesPoint {
  label: string;
  value: number;
  secondary?: number;
}
